const createQuery = () => `
  ... on MailchimpWidget {
    title
    audienceId
  }
`
export default createQuery
